import React, { Component } from 'react';

//style
import './Index.scss';

//Componentes
import Section from '../../Components/Section-Principal/SectionPrincipal';
import SectionProductos from '../../Components/Section-Productos/SectionProductos'
import Servicios from '../../Components/Section-servicios/SectionServicios';
import Information from '../../Components/Information/Information';

class index extends Component {
  render() {
    return (
      <div >
        <div className="index" >
          <Section/>
          <SectionProductos/>
          <Information/>
          <Servicios/>
        </div>
      </div>
    );
  }
}

export default index;



// WEBPACK FOOTER //
// ./src/Pages/Index/Index.jsx